import { configureStore } from '@reduxjs/toolkit';

// App
import AppSlice from '../AppSlice';
import SessionTimeoutDialogSlice from '../components/base/SessionTimeoutDialog/SessionTimeoutDialogSlice';
import NotificationSnackbarSlice from '../components/base/NotificationSnackbar/NotificationSnackbarSlice';
import LoadingBackdropSlice from '../components/base/LoadingBackdrop/LoadingBackdropSlice';

// Page slices

// User Pages
import UserApplicationSlice from '../pages/user/UserApplication/UserApplicationSlice';
import UserHistorySlice from '../pages/user/UserHistory/UserHistorySlice';

export const store = configureStore({
  reducer: {
    app: AppSlice.reducer,
    sessionTimeoutDialog: SessionTimeoutDialogSlice.reducer,
    snackbarNotification: NotificationSnackbarSlice.reducer,
    loadingBackdrop: LoadingBackdropSlice.reducer,
    userCreate: UserApplicationSlice.reducer,
    userHistory: UserHistorySlice.reducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});
